import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Payouts from "components/Panel/Reseller/Payouts";
import { useDispatch, useSelector } from "react-redux";
import { getPayouts } from "redux/reseller/payout/payoutSlice";
import Pagination from "components/Pagination";
import Button from "components/Button";
import { FaExchangeAlt, FaUniversity, FaBitcoin } from "react-icons/fa";

const PayoutsContainer = () => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.resellerPayouts.payouts);
  const { total, pages, page, per_page } = useSelector(
    (state) => state.resellerPayouts.payouts
  );
  useEffect(() => {
    dispatch(getPayouts({ page: 1, per_page: 15 }));
  }, [dispatch]);

  const handlePageChange = (newPage) => {
    dispatch(getPayouts({ page: newPage, per_page: 15 }));
  };

  return (
    <div className="bg-black min-h-screen">
      <div className="p-4 flex flex-col gap-4 md:flex-row md:justify-between md:items-center">
        <h2 className="text-xl font-semibold text-white-100">
          Para Çekme Taleplerim
        </h2>
        <div className="flex flex-col gap-2 sm:flex-row sm:gap-2 text-white-100">
          <Link to={"/reseller/transfers/create"}>
            <Button variant="small" className="bg-blue-600 hover:bg-blue-700 flex items-center gap-2">
              <FaExchangeAlt className="text-md" />
              Bayiye Transfer
            </Button>
          </Link>
          <Link to={"/reseller/payouts/create?type=iban"}>
            <Button variant="small" className="bg-rose-700 hover:bg-rose-800 flex items-center gap-2">
              <FaUniversity className="text-md" />
              IBAN Çekim Talebi
            </Button>
          </Link>
          <Link to={"/reseller/payouts/create?type=crypto"}>
            <Button variant="small" className="bg-green-600 hover:bg-green-700 flex items-center gap-2">
              <FaBitcoin className="text-md" />
              Kripto Çekim Talebi
            </Button>
          </Link>
        </div>
      </div>
      <Payouts data={data} />
      <Pagination
        currentPage={page}
        totalPages={pages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default PayoutsContainer;
